import { Modal } from "../../components/ui/Modal";
import { formatCurrency } from "../../lib/utils";
import { Requisition } from "./@types";

interface RequisitionModalProps {
  isOpen: boolean;
  onClose: () => void;
  requisition: Requisition;
}

const RequisitionDetailsModal: React.FC<RequisitionModalProps> = ({
  isOpen,
  onClose,
  requisition,
}) => {
  const handleCloseModal = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCloseModal}
      title="Requisition Details"
      className="max-w-full sm:max-w-[80vw] lg:max-w-[45vw] w-full bg-white max-h-[90vh] overflow-y-auto"
    >
      <div className="p-8">
        <div className="p-4 space-y-4 border border-gray-200 rounded-[10px]">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <span className="text-[13px] mb-2">Card ID</span>
              <div className="bg-[#F6F6F6] border border-[#F6F6F6] h-[48px] pl-4 text-[13px] font-normal flex items-center rounded-[10px]">
                {requisition.cardId}
              </div>
            </div>
            <div className="flex flex-col">
              <span className="text-[13px] mb-2">Description</span>
              <div className="bg-[#F6F6F6] border border-[#F6F6F6] h-[48px] pl-4 text-[13px] font-normal flex items-center rounded-[10px]">
                {requisition.description}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <span className="text-[13px] mb-2">Amount</span>
              <div className="bg-[#F6F6F6] border border-[#F6F6F6] h-[48px] pl-4 text-[13px] font-normal flex items-center rounded-[10px]">
                {formatCurrency(requisition.totalAmount)}
              </div>
            </div>
            <div className="flex flex-col">
              <span className="text-[13px] mb-2">Amount</span>
              <div className="bg-[#F6F6F6] border border-[#F6F6F6] h-[48px] pl-4 text-[13px] font-normal flex items-center rounded-[10px]">
                {formatCurrency(requisition.totalPayment)}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <span className="text-[13px] mb-2">Paid to</span>
              <div className="bg-[#F6F6F6] border border-[#F6F6F6] h-[48px] pl-4 text-[13px] font-normal flex items-center rounded-[10px]">
                {requisition.payTo}
              </div>
            </div>
            <div className="flex flex-col">
              <span className="text-[13px] mb-2">Bank</span>
              <div className="bg-[#F6F6F6] border border-[#F6F6F6] h-[48px] pl-4 text-[13px] font-normal flex items-center rounded-[10px]">
                {requisition.bankName}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RequisitionDetailsModal;
